export const LIVE_CHAT_ID = "reputech_live_chat_id";
